import { UserService } from '../../services/user.service';

import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export const MODULES = [
  CommonModule,
  MatCardModule,
  ReactiveFormsModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatCheckboxModule,
  MatButtonModule,
  TranslateModule,
];

@Component({
  selector: 'app-user-admin-contact-tab',
  templateUrl: './user-admin-contact-tab.component.html',
  styleUrls: ['../../user-admin.component.scss'],
  imports: [...MODULES, FaIconComponent],
})
export class UserAdminContactTabComponent {
  private readonly userService = inject(UserService);

  contactFormWasSent = input<boolean>();
  contactSubjects = input<string[]>();

  sendContactForm = output<void>();

  get contactFormGroup(): UntypedFormGroup {
    return this.userService.contactFormGroup;
  }

  onSendContactForm(): void {
    this.sendContactForm.emit();
  }

  onResetContactForm(): void {
    this.contactFormGroup.reset();
  }
}
